/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerBranchOfficeDto } from '../../models/customer-branch-office-dto';

export interface GetCustomerBranchOffices$Params {

/**
 * customer id
 */
  customerId: number;
}

export function getCustomerBranchOffices(http: HttpClient, rootUrl: string, params: GetCustomerBranchOffices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerBranchOfficeDto>>> {
  const rb = new RequestBuilder(rootUrl, getCustomerBranchOffices.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerBranchOfficeDto>>;
    })
  );
}

getCustomerBranchOffices.PATH = '/customers/{customerId}/branch-offices';
